module.exports = __webpack_public_path__ + "static/img/Amazing.b095dfde.png";